import {showAuthorizeAgentDialog} from '../../../../../actions'
import {useAppDispatch, useAppSelector} from '../../../../../hooks/react-redux'
import {getAgent, getAgentInCloud, getIsAgentTypeManageable} from '../../../../../selectors'
import {restApi} from '../../../../../services/rest'
import type {AgentId} from '../../../../../types'

import AuthorizeAgent from './AuthorizeAgent'

type Props = {
  agentId: AgentId
  className?: string
}

export default function AuthorizeAgentContainer(props: Props) {
  const poolId = useAppSelector(state => getAgent(state, props.agentId)?.pool?.id)
  const typeId = useAppSelector(state => getAgent(state, props.agentId)?.typeId)
  const isCloud = useAppSelector(state => getAgentInCloud(state, props.agentId) || false)
  const {isAuthorizeable} = restApi.endpoints.getPoolPermissions.useQuery(undefined, {
    selectFromResult: ({data}) => ({
      isAuthorizeable: poolId != null && (data?.[poolId]?.canChangeStatus ?? false),
    }),
  })
  const isAgentTypeManageable = useAppSelector(
    state => typeId != null && getIsAgentTypeManageable(state, typeId),
  )
  const dispatch = useAppDispatch()
  return (
    <AuthorizeAgent
      {...props}
      isAuthorizeable={isAuthorizeable && isAgentTypeManageable}
      poolId={poolId}
      isCloud={isCloud}
      showAuthorizeAgentDialog={(...args) => dispatch(showAuthorizeAgentDialog(...args))}
    />
  )
}
